import { ClientRouteOptions, TypedClientAjaxProxy } from "@cervval.js/client-html5-spa/routes";
import { AuthInfosRoutes, LoginDataRoutes, LoginFormAuthRoutes } from "@cervval.js/common-auth/src/authRoutes";
import { LOG_SERVICE, LogService } from "@cervval.js/common/services";
import { Injectable } from "@cervval.js/common/src/dependencies/injectable";
import { Injected } from "@cervval.js/common/src/dependencies/injected";
import { AppLoginData } from "@zurvan-terminal/zt-datamodel";

export const LOGIN_CLIENT_MAIN_SERVICE = "LoginClientMainService";

@Injectable(LOGIN_CLIENT_MAIN_SERVICE)
export class LoginClientMainService {
    @Injected(LOG_SERVICE)
    public log!: LogService;

    @TypedClientAjaxProxy({ urlPrefix: "../" })
    public authInfosRoutes!: AuthInfosRoutes<ClientRouteOptions>;

    @TypedClientAjaxProxy({ urlPrefix: "../" })
    public loginFormAuthRoutes!: LoginFormAuthRoutes<unknown, ClientRouteOptions>;

    @TypedClientAjaxProxy()
    public loginDataRoutes!: LoginDataRoutes<AppLoginData, ClientRouteOptions>;
}